import React, { useEffect, useState } from 'react';
import { Table } from 'semantic-ui-react';
import { HudproArchive } from '../types';
import { TableHeader } from './TableHeader';
import moment from 'moment';

interface PropTypes {
  hudpro: HudproArchive[];
}

const onRowClick = (orderId: number) => {
  window.open(`/orders/order-information/${orderId}/-1/documents`, 'blank');
};

const TableRow = ({ hudproArchive }: { hudproArchive: HudproArchive }) => (
  <Table.Row
    key={hudproArchive.hdsNumber}
    onClick={() => onRowClick(hudproArchive.orderId)}
    style={{ cursor: 'pointer' }}
  >
    <Table.Cell collapsing>{moment(hudproArchive.orderDate).format('MM/DD/YYYY')}</Table.Cell>
    <Table.Cell collapsing>
      <b>{hudproArchive.hdsNumber}</b>
    </Table.Cell>
    <Table.Cell collapsing>{hudproArchive.address}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.municipality}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.subMunicipality}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.county}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.searchOrdered}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.section}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.block}</Table.Cell>
    <Table.Cell collapsing>{hudproArchive.lot}</Table.Cell>
  </Table.Row>
);

const HudproArchiveTab = (props: PropTypes) => {
  const [sortedHudpro, setSortedHudpro] = useState<HudproArchive[]>([]);
  useEffect(() => {
    if (props.hudpro) {
      setSortedHudpro(props.hudpro);
    }
  }, [props.hudpro]);
  return (
    <React.Fragment>
      {sortedHudpro.length === 0 ? (
        <div>No Records Available</div>
      ) : (
        <Table striped columns={12} sortable>
          <TableHeader
            columnNames={[
              'Order Date',
              'HDS Number',
              'Address',
              'Municipality',
              'Submunicipality',
              'County',
              'Search',
              'Section',
              'Block',
              'Lot',
            ]}
            sortedData={sortedHudpro}
            setSortedData={setSortedHudpro}
          />
          <Table.Body>
            {sortedHudpro.map(hp => (
              <TableRow hudproArchive={hp} />
            ))}
          </Table.Body>
        </Table>
      )}
    </React.Fragment>
  );
};

export default HudproArchiveTab;
